module.exports = __webpack_public_path__ + "static/media/avatar3.2acce61d.jpg";